import installationInstructions from './installationInstructions';

const sensorCategoryContent = {
  installationInstructions
}

export { sensorCategoryContent };
